export const certificateApplicationPostOfficeCreateDtoDeliveryMethodEnum = {
  '1': 1,
  '2': 2,
  '10': 10,
} as const

export type CertificateApplicationPostOfficeCreateDtoDeliveryMethodEnum =
  (typeof certificateApplicationPostOfficeCreateDtoDeliveryMethodEnum)[keyof typeof certificateApplicationPostOfficeCreateDtoDeliveryMethodEnum]

export const certificateApplicationPostOfficeCreateDtoPaymentSystemEnum = {
  freedom: 'freedom',
  kaspi: 'kaspi',
} as const

export type CertificateApplicationPostOfficeCreateDtoPaymentSystemEnum =
  (typeof certificateApplicationPostOfficeCreateDtoPaymentSystemEnum)[keyof typeof certificateApplicationPostOfficeCreateDtoPaymentSystemEnum]

export type CertificateApplicationPostOfficeCreateDto = {
  /**
   * @minLength 1
   * @maxLength 100
   * @type string
   */
  certificate_number: string
  /**
   * @minLength 1
   * @maxLength 250
   * @type string
   */
  city: string
  /**
   * @minLength 1
   * @maxLength 30
   * @type string
   */
  zip_code: string
  /**
   * @minLength 11
   * @maxLength 12
   * @type string
   */
  phone: string
  /**
   * @minLength 1
   * @maxLength 250
   * @type string
   */
  address: string
  /**
   * @type string
   */
  email: string
  /**
   * @minLength 1
   * @maxLength 250
   * @type string
   */
  full_name: string
  /**
   * @type number
   */
  delivery_method: CertificateApplicationPostOfficeCreateDtoDeliveryMethodEnum
  /**
   * @minLength 12
   * @maxLength 12
   * @type string
   */
  iin: string
  /**
   * @type string
   */
  payment_system: CertificateApplicationPostOfficeCreateDtoPaymentSystemEnum
}